const DOT_NUMBER_FORMAT_REGEX = /^\d{2,8}$/
const CONTAINS_LETTER_REGEX = /[a-zA-Z]/

/**
 * Mirrors the API's `sanitizeDotNumber` (api/src/lib/utils/dot.utils.ts):
 * strips formatting and leading zeros, then requires 2-8 digits. "0053467" and
 * "53-467" both become "53467"; anything with a letter is null.
 */
export const sanitizeDotNumber = (
  value: string | null | undefined
): string | null => {
  const trimmed = value?.trim()
  if (!trimmed || CONTAINS_LETTER_REGEX.test(trimmed)) return null
  const normalized = trimmed.replace(/\D/g, '').replace(/^0+/, '')
  return DOT_NUMBER_FORMAT_REGEX.test(normalized) ? normalized : null
}
